module.exports = global.RosClient = require("./RosLibJsClient");


//////////////////
// WEBPACK FOOTER
// ./node_modules/roslib-client/src/browser.js
// module id = 361
// module chunks = 0